
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 10.003l-3 .54.5-3.04 5.73-5.71a1 1 0 011.42 0l1.06 1.06a1 1 0 010 1.42L8 10.003z","stroke":"#545C69","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M12.5 10.503v3a1 1 0 01-1 1H2a1 1 0 01-1-1v-9.5a1 1 0 011-1h3","stroke":"#545C69","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    